import { render, staticRenderFns } from "./ProductConfigurator.vue?vue&type=template&id=2558459e&scoped=true&"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js&"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558459e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2558459e')) {
      api.createRecord('2558459e', component.options)
    } else {
      api.reload('2558459e', component.options)
    }
    module.hot.accept("./ProductConfigurator.vue?vue&type=template&id=2558459e&scoped=true&", function () {
      api.rerender('2558459e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductConfigurator.vue"
export default component.exports